
//custom components
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import ToastAlert from '@/components/ToastAlert.vue'

//axios
import axios from "axios";

//this view
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeView",
  data() {
    return {
      config: [] as any[any],
      status: 'loading',
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      confirmation: false,
      qrId: '',
      isPhoneValid: false
    };
  },
  components: {
    VueTelInput,
    ToastAlert
  },
  async created(){
    const getConfig = await axios.get('/config.json')
    this.config = getConfig.data
    this.status = 'idle'
  },
  methods: {
    async register() {
      //init error flag
      let error = 0;

      //check form fields
      if (!this.firstName || !this.lastName || !this.email || !this.phone) {
        error = 1
      }

      if (error) {
        (this.$refs as any).toast.show("Faltan completar campos")
        throw 'Faltan completar campos'
      }

      //check phone
      if(!this.isPhoneValid){
        (this.$refs as any).toast.show("Ingrese un télefono válido")
        throw 'Ingrese un télefono válido'
      }

      //check email
      if( !this.validateEmail(this.email) ){
        (this.$refs as any).toast.show("Ingresar un email válido")
        throw 'Ingresar un email válido'
      }

      //check confirmation
      if(!this.confirmation){
        (this.$refs as any).toast.show("Debe confirmar asistencia")
        throw 'Debe confirmar asistencia'
      }

      this.status = 'loading'

      //data to post
      const data = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        confirmation: this.confirmation,
        emailSubject: this.config.emailSubject
      }

      //post data
      const response = await axios.post(this.config.apiUrl+'/create-invite.php', data)
        .catch(() => {
          this.status = 'error'
        }) as any

      if (response.data.status) {
        this.qrId = response.data.qrId
        this.status = 'success'
      }
      else {
        this.status = 'error'
      }

    },
    retry() {
      this.status = 'idle'
    },
    validateEmail(email:string) {
      /* eslint-disable no-useless-escape */
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true
      }
      else {
        return false
      }
    },
    validatePhone(phone:any[string]){
      this.isPhoneValid = phone.valid
      console.log(this.isPhoneValid)
    }
  }
});
